import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";

export default function Impressum() {
    const [data, setData] = useState(null);

    useEffect(() => {}, []);

    return (
        <div className="container my-5">
            <div className="row">
                <div className="col mt-3 mb-5 text-start">
                    <h2 className="mb-5">Impressum</h2>
                    {/* <p>Angaben gemäß § 5 TMG:</p> */}
                    <p>
                        <h4>
                            <strong>Sabine Stroh</strong>
                        </h4>
                    </p>
                    <p>
                        <strong>OsteoFemme </strong>
                    </p>
                    <p>
                        <strong> Praxis für Osteopathie:</strong>
                        <br />
                        Hainer Trift 25 <br /> 63303 Dreieich - Buchschlag
                        <br />
                        {/* <strong> Praxis Standort 2:</strong> <br /> Am Weingarten 25,
                        <br /> 60487 Frankfurt <br />
                        <br />
                        /o PhysioComplete
                        <br /> */}
                    </p>
                    <p>
                        <strong> Kontakt:</strong> <br></br>Telefon: +49 176 2015 8693<br></br>
                        E-Mail: sabine.stroh@osteofemme.de
                    </p>
                    <p>
                        <strong>Verantwortlich für die Website (gem. § 55 Abs. 2 RStV): </strong>
                        <br />
                        Sabine Stroh
                    </p>
                    <p>
                        <strong> Berufsbezeichnung und Berufsrechtliche Regelungen: </strong> <br />
                        <ul>
                            <li>Heilpraktikerin (verliehen in der Bundesrepublik Deutschland)</li>
                            <li>
                                {" "}
                                Amtsärztliche Überprüfung und Behördliche Erlaubnis durch Gesundheitsamt Kreis Offenbach{" "}
                            </li>
                        </ul>
                    </p>
                    <p>
                        {" "}
                        <strong> Rechtsgrundlage der Heilpraktiker Tätigkeit:</strong> <br />
                        Heilpraktikergesetz und Durchführungsverordnung, nachzulesen im Internet unter: <br />
                        <a href="http://www.gesetze-im-internet.de/heilprg/index.html">
                            http://www.gesetze-im-internet.de/heilprg/index.html
                        </a>
                        und <br />
                        <a href=" http://www.gesetze-im-internet.de/heilprgdv_1/index.html">
                            http://www.gesetze-im-internet.de/heilprgdv_1/index.html
                        </a>
                    </p>
                    <p>
                        <strong> Zuständige Aufsichtsbehörde:</strong>
                        <br />
                        Gesundheitsamt Kreis Offenbach
                    </p>
                    <p>
                        <strong> Berufshaftpflichtversicherung:</strong>
                        <br />
                        Continentale Sachversicherung AG, Dortmund - Geltungsraum: Deutschland
                    </p>
                    <p>
                        <strong> Berufsverbandsmitgliedschaften:</strong>
                        <br />
                        <ul>
                            <li> Verband der Osteopathen Deutschland VOD e.V., Mitgliedsnummer VOD: 2144896059 </li>
                            <li>Bund Deutscher Heilpraktiker BDH e.V., Mitgliedsnummer BDH: 200 151</li>
                        </ul>
                    </p>
                    <p>
                        <strong>Internet Disclaimer / Haftungsausschluss </strong>
                        <br />
                        Ich begrüße jede Interessierte* auf meiner Website.{" "}
                    </p>
                    {/* <p>
                        <strong>Haftung für Inhalte</strong>
                        <br></br> Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                        nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter
                        jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
                        oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                    </p> */}
                    <p>
                        Ich weise darauf hin, dass sich diese Website und sämtliche Informationen auf der Website nach
                        deutschem Recht richten. Jede Benutzerin, welche über diesen Disclaimer hinweggeht, um auf meine
                        einzelnen Seiten Zugriff zu nehmen, erkennt mit dem Weiterblättern der Seite an, dass sich die
                        Beziehung zwischen ihr und mir ausschließlich nach deutschem Recht richtet.
                    </p>
                    <p>
                        Vorsorglich weise ich darauf hin, dass die von mir abgegebenen Informationen auf der Website
                        nicht genutzt werden können, um Krankheiten oder Leiden selbst zu erkennen und therapieren.
                    </p>
                    <p>
                        Für die Vollständigkeit oder Richtigkeit der Informationen auf dieser Website kann ich keine
                        Garantie übernehmen.
                    </p>
                    <p>
                        Ich kann nicht ausschließen, dass meine Internetseiten auch Informationen durch Dritte
                        aufweisen. Für diese Informationen kann ich keine Haftung übernehmen. Dies gilt vor allem auch
                        für Links zu anderen Websites, die ich zwar immer wieder daraufhin überprüfe, ob sie
                        rechtswidrige Inhalte enthalten, aber keine Gewähr dafür leisten kann. Die Inhalte dieser Seiten
                        stellen nicht meine Meinung dar, die Links werden nur zur Verbesserung der Informationsvielfalt
                        veröffentlicht.
                    </p>
                    <p>
                        Sämtliche Texte und Grafiken auf meinen Webseiten sind urheberrechtlich oder durch sonstige
                        Schutzrechte geschützt. Der Gebrauch oder die Vervielfältigung dieser Grafiken und Texte ist
                        ohne die vorherige schriftliche Genehmigung durch mich nicht gestattet. Insbesondere werde ich
                        es nicht gestatten, dass Produktbezeichnungen, welche grundsätzlich Markenschutz genießen, von
                        Dritten gebraucht werden.
                    </p>
                    <p>
                        Um die Internetseite aktuell halten zu können, werde ich selbstverständlich die Texte
                        gegebenenfalls ändern und / oder ergänzen. Eine Haftung aus dem Inhalt der Internetseiten ergibt
                        sich nicht.
                    </p>
                    <p>* Statt zu gendern, nutze ich die weibliche Anrede.</p>

                    {/*                     
 * Gilt für Frauen, Männer und Diverse
                    gleichermaßen *************************** Und folgender Hinweis muss noch in die Seite integriert
                    werden: Hinweis: Aus rechtlichen Gründen weise ich explizit darauf hin, dass alle aufgeführten
                    Krankheitsbilder und Diagnosen beispielhaften Charakter tragen und diese Aufzählungen keineswegs den
                    Anspruch auf Vollständigkeit erheben. Diese Angaben sind empirischer Natur und beruhen auf den
                    jahrzehntelangen Erfahrungen vieler Therapeuten. Sie enthalten keinerlei Heilversprechen oder eine
                    Garantie zur Linderung der Beschwerden oder Symptome. *********************** Eine potentielle
                    Einleitung zum Newsletter „Gesundheit aus Frauenperspektive": Seit April 2021 gibt es den ersten (!)
                    Lehrstuhl für Geschlechtersensible Medizin in Deutschland. (Verlinken:
                    https://aktuell.uni-bielefeld.de/2021/04/21/professur-zu-geschlechtersensibler-medizin/)
                    'Geschlechtersensible Medizin' umfasst sowohl die biologisch-naturwissenschaftlichen Aspekte ( 'sex'
                    ) als auch die sozio-kulturellen ( 'gender' ) sowie die personellen, d.h. die möglichen
                    Geschlechterkonstellationen von Patientinnen, Patienten, Ärztinnen, Ärzten, Lehrenden und
                    Studierenden. Auch international gibt es zwar viele Absichtserklärungen und gesetzliche
                    Rahmenbedingungen zur zwischen den Geschlechtern gleichberechtigten Forschung und medizinischen
                    Behandlung, aber die Umsetzung erfolgt leider schleppend. Feministische Frauenbewegungen im In- und
                    Ausland bzw. national und international mahnen seit den 1970’er Jahren und somit seit bald einem
                    halben Jahrhundert gleichberechtigte medizinische Auseinandersetzung an. Hieraus resultieren sowohl
                    Impetus als auch einige der spannenderen Erkenntnisse. In dieser Rubrik werde ich künftig positive
                    und kritische Auseinandersetzungen mit den Spezifika von Frauengesundheit in Form eines Newsletters
                    aufgreifen. Gerne können Sie sich hierdafür anmelden. */}
                </div>
            </div>
        </div>
    );
}
